var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": "시설·장비예약"
    }
  }), _c('rental-navigation-row'), _c('section', {
    staticClass: "section",
    attrs: {
      "id": "retnal-subject-list-section"
    }
  }, [_c('v-container', [_c('rental-subject-filter'), _vm._l(_vm.subjects, function (item) {
    return _c('rental-subject-card', _vm._b({
      key: item === null || item === void 0 ? void 0 : item._id,
      staticClass: "mt-60"
    }, 'rental-subject-card', {
      item: item
    }, false));
  }), _c('v-pagination', {
    staticClass: "mt-60 mb-60",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page: page
          })
        });
      }
    }
  })], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }